import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardActiveStepId = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.activeStepId
)
